module.exports = __webpack_public_path__ + "img/oxxo.737d11c.svg";